module.exports = __webpack_public_path__ + "static/img/01_click.1c113c94.png";